const nav = document.querySelector(".product-board-nav");
const trigger = document.querySelector(".mobile-trigger");

if(nav && trigger){
    trigger.addEventListener("click", function () {
        nav.classList.toggle("open");
    });
}


/** Light On Feature */
class LightOnToggle {
  constructor(container) {
    this.container = container;
    this.button = container.querySelector('.light-toggle__button');
    this.buttonLabel = container.querySelector('.light-toggle__label');
    this.productGrid = document.querySelector('section.section.section-product-landing');
    this.isActive = false;
    this.isInTransition = false;
    this.images = [];

    this.init();
  }

  init() {
    if (!this.button || !this.productGrid) return;

    this.images = Array.from(
      this.productGrid.querySelectorAll('.image.image-cover[data-light-on]')
    ).map((img) => ({
      el: img,
      defaultBg: img.getAttribute('data-bg'),
      lightOnBg: img.getAttribute('data-light-on').replace(/^url\(["']?/, '').replace(/["']?\)$/, '')
    }));

    this.button.addEventListener('click', () => this.toggle());
  }

  toggle() {
    if (this.isInTransition) return;

    this.isInTransition = true;
    this.isActive = !this.isActive;

    this.container.classList.toggle('is-active', this.isActive);
    this.button.setAttribute('aria-pressed', this.isActive ? 'true' : 'false');
    this.buttonLabel.innerText = this.isActive ? 'Lights ON' : 'Lights OFF';

    this.images.forEach((item) => {
      var nextBg = this.isActive ? item.lightOnBg : item.defaultBg;

      item.el.style.backgroundImage = 'url(' + nextBg + ')';
      item.el.setAttribute('data-bg', nextBg);
    });

    setTimeout(() => {
      this.isInTransition = false;
    }, 300);
  }
}

document.querySelectorAll('[data-toggle]').forEach((toggleEl) => {
  new LightOnToggle(toggleEl);
});
document.addEventListener('DOMContentLoaded', function () {
  var announcementBar = document.querySelector('.announcement-bar');
  var announcementClose = document.querySelector('.announcement-bar-close');
  var storageKey = 'announcementBarClosedThisSession';

  if (!announcementBar) return;

  if (sessionStorage.getItem(storageKey) === 'true') {
    announcementBar.style.display = 'none';
    document.body.classList.remove('is-announcement-bar');
    document.body.classList.remove('announcement-bar-scrolled');
  }

  if (announcementClose) {
    announcementClose.addEventListener('click', function () {
      sessionStorage.setItem(storageKey, 'true');

      announcementBar.style.display = 'none';
      document.body.classList.remove('is-announcement-bar');
      document.body.classList.remove('announcement-bar-scrolled');
    });
  }
});
document.addEventListener('change', function (event) {
  var input = event.target;

  if (!input.matches('.product-form input[type="radio"][name="id"]')) return;

  var selectedVariantId = input.value;

  document.querySelectorAll('.display-for-variant').forEach(function (block) {
    if (block.getAttribute('data-variant-id') === selectedVariantId) {
      block.classList.add('show');
      block.classList.remove('hide');
    } else {
      block.classList.remove('show');
    }
  });

  var enquireButton = document.getElementById('enquire_btn');
  var enquire = document.getElementById('enquire');

  if (enquireButton) {
    enquireButton.classList.remove('active');
    enquireButton.checked = false;
  }

  if (enquire) {
    enquire.classList.remove('active');
  }
});

function balanceProductReassurance() {
  document.querySelectorAll('.product-reassurance').forEach(function (list) {
    if (!window.matchMedia('(min-width: 769px)').matches) {
      list.style.removeProperty('--reassurance-rows');
      return;
    }

    var visibleItems = Array.from(list.children).filter(function (item) {
      return window.getComputedStyle(item).display !== 'none';
    }).length;

    list.style.setProperty('--reassurance-rows', Math.ceil(visibleItems / 2));
  });
}

document.addEventListener('DOMContentLoaded', balanceProductReassurance);
window.addEventListener('resize', balanceProductReassurance);
document.addEventListener('change', function (event) {
  if (event.target.matches('.product-form input[type="radio"][name="id"]')) {
    balanceProductReassurance();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var preloadedProductCardImages = Object.create(null);

  function preloadProductCardImage(url) {
    if (!url) return null;

    if (preloadedProductCardImages[url]) {
      return preloadedProductCardImages[url];
    }

    var preload = new Image();
    preload.src = url;
    preloadedProductCardImages[url] = preload;
    return preload;
  }

  function preloadProductCardImages(urls) {
    urls.forEach(function (url) {
      preloadProductCardImage(url);
    });
  }

  function whenProductCardImageReady(url, callback) {
    var preload = preloadProductCardImage(url);

    if (!preload) return;

    if (preload.complete) {
      callback();
      return;
    }

    preload.onload = callback;
  }

  document.querySelectorAll('.product-card-gallery').forEach(function (gallery) {
    var image = gallery.querySelector('.image.image-cover');
    var hoverImage = gallery.querySelector('.image-hover');
    var prev = gallery.querySelector('.product-card-gallery__arrow--prev');
    var next = gallery.querySelector('.product-card-gallery__arrow--next');
    var images = [];
    var hoverImageUrl = hoverImage ? hoverImage.getAttribute('data-bg') : null;
    var touchStartX = null;
    var didSwipe = false;

    try {
      images = JSON.parse(gallery.getAttribute('data-gallery-images') || '[]');
    } catch (error) {
      images = [];
    }

    if (hoverImageUrl) {
      preloadProductCardImages([hoverImageUrl]);
    }

    if (!image || images.length < 2) return;

    preloadProductCardImages(images);

    function setImage(index) {
      var safeIndex = (index + images.length) % images.length;
      var nextImage = images[safeIndex];

      whenProductCardImageReady(nextImage, function () {
        gallery.setAttribute('data-gallery-index', safeIndex);
        image.removeAttribute('data-bg');
        image.style.backgroundImage = 'url(' + nextImage + ')';
        image.classList.add('loaded');
      });
    }

    function restorePrimaryImage() {
      var activeLightToggle = document.querySelector(
        '.light-toggle.is-active .light-toggle__button[aria-pressed="true"]'
      );
      var lightOnImage = image.getAttribute('data-light-on');

      if (activeLightToggle && lightOnImage) {
        lightOnImage = lightOnImage.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');

        whenProductCardImageReady(lightOnImage, function () {
          gallery.setAttribute('data-gallery-index', '0');
          image.style.backgroundImage = 'url(' + lightOnImage + ')';
          image.setAttribute('data-bg', lightOnImage);
          image.classList.add('loaded');
        });
        return;
      }

      setImage(0);
    }

    function move(direction) {
      var current = parseInt(gallery.getAttribute('data-gallery-index') || '0', 10);
      gallery.classList.add('is-gallery-active');
      setImage(current + direction);
    }

    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        move(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        move(1);
      });
    }

    if (window.matchMedia('(hover: hover) and (min-width: 769px)').matches) {
      gallery.addEventListener('mouseleave', function () {
        gallery.classList.remove('is-gallery-active');
        restorePrimaryImage();
      });
    }

    gallery.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
      didSwipe = false;
    }, { passive: true });

    gallery.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;

      var deltaX = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;

      if (Math.abs(deltaX) < 22) return;

      didSwipe = true;
      move(deltaX < 0 ? 1 : -1);
    }, { passive: true });

    gallery.addEventListener('click', function (event) {
      if (!didSwipe) return;

      event.preventDefault();
      event.stopPropagation();
      didSwipe = false;
    }, true);
  });
});
/* ===== CreativeFold — Enquire -> Shopify Forms modal (Form 1054979, shadow DOM embed) ===== */
(function () {
  var modal, panel, moved = false;
  function embed(){ return document.querySelector('shopify-forms-embed'); }
  function productValue(){
    var btn = document.getElementById('enquire');
    var title = btn ? (btn.getAttribute('data-product-title') || '') : '';
    var sizeEl = document.querySelector('.product-variant-radios input:checked + label');
    var size = sizeEl ? sizeEl.textContent.trim() : '';
    return (size && !/one size|default/i.test(size)) ? (title + ' – ' + size) : title;
  }
  function prefill(){
    var e = embed(); if (!e || !e.shadowRoot) return;
    var lab = [].slice.call(e.shadowRoot.querySelectorAll('label')).find(function(l){ return /product/i.test(l.textContent); });
    var input = lab && (lab.control || (lab.parentElement && lab.parentElement.querySelector('input,textarea')));
    if (input) {
      input.value = productValue();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function buildModal(){
    modal = document.createElement('div');
    modal.className = 'cf-modal';
    modal.setAttribute('hidden', '');
    modal.innerHTML = '<div class="cf-modal__panel" role="dialog" aria-modal="true" aria-label="Product enquiry">' +
      '<button type="button" class="cf-modal__close" aria-label="Close">×</button>' +
      '<div class="cf-modal__slot"></div></div>';
    document.body.appendChild(modal);
    panel = modal.querySelector('.cf-modal__slot');
    modal.addEventListener('click', function(e){ if (e.target === modal || (e.target.closest && e.target.closest('.cf-modal__close'))) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) close(); });
  }
  function styleEmbedTitle(e){
    try {
      var sr = e && e.shadowRoot;
      if (!sr || sr.querySelector('style[data-cf-title-font]')) return;
      var st = document.createElement('style');
      st.setAttribute('data-cf-title-font', '1');
      /* restyle the form's heading + submit button to match the theme (din_condensedbold) */
      st.textContent = 'h1,h2,h3,h4{font-family:"din_condensedbold","Arial",sans-serif !important;text-transform:uppercase;letter-spacing:normal}'
        + ' button[type="submit"],input[type="submit"],[type="submit"]{font-family:"din_condensedbold","Arial",sans-serif !important;text-transform:uppercase !important;letter-spacing:.04em !important}';
      sr.appendChild(st);
    } catch (err) {}
  }
  function open(){
    var e = embed();
    if (!e) { window.location.href = '/pages/contact?source=product-enquiry'; return; }
    if (!modal) buildModal();
    if (!moved) { panel.appendChild(e); e.style.display = ''; moved = true; }
    styleEmbedTitle(e); setTimeout(function(){ styleEmbedTitle(e); }, 300);
    modal.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(prefill, 80); setTimeout(prefill, 500);
  }
  function close(){ if (!modal) return; modal.setAttribute('hidden', ''); document.documentElement.style.overflow = ''; }
  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('#enquire');
    if (t) { e.preventDefault(); open(); }
  });
  var tries = 0;
  (function init(){
    var e = embed();
    if (e) { var sec = e.closest('.shopify-section') || e.parentElement; if (sec) sec.classList.add('cf-enquiry-hidden'); }
    else if (tries++ < 30) { setTimeout(init, 300); }
  })();
})();

/* ===== CreativeFold — Desktop gallery thumbnail swap ===== */
(function () {
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest && e.target.closest('.cf-thumb');
    if (!thumb) return;
    e.preventDefault();
    var g = thumb.closest('.cf-gallery');
    var main = g && g.querySelector('.cf-gallery__img');
    if (!main) return;
    if (thumb.dataset.full) main.src = thumb.dataset.full;
    if (thumb.dataset.w) main.setAttribute('width', thumb.dataset.w);
    if (thumb.dataset.h) main.setAttribute('height', thumb.dataset.h);
    if (thumb.dataset.zoom) main.setAttribute('data-zoom-src', thumb.dataset.zoom);
    main.setAttribute('data-image-index', thumb.dataset.index || '0');
    main.setAttribute('data-zoom-orientation', thumb.dataset.orientation || 'portrait');
    [].forEach.call(g.querySelectorAll('.cf-thumb'), function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });
})();

/* ===== CreativeFold — Mobile gallery thumbnail strip synced to swiper ===== */
(function () {
  function wire(scope) {
    var swiperEl = scope.querySelector('.productswiper');
    var strip = scope.querySelector('.cf-mthumbs');
    if (!swiperEl || !strip) return true; /* nothing to wire here */
    var sw = swiperEl.swiper;
    if (!sw) return false; /* swiper not initialised yet */
    var btns = [].slice.call(strip.querySelectorAll('.cf-mthumb'));
    function setActive(i) {
      btns.forEach(function (b, idx) { b.classList.toggle('is-active', idx === i); });
      if (btns[i]) btns[i].scrollIntoView({ inline: 'nearest', block: 'nearest' });
    }
    strip.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.cf-mthumb');
      if (!b) return;
      var i = parseInt(b.getAttribute('data-index'), 10) || 0;
      if (sw.params && sw.params.loop && sw.slideToLoop) sw.slideToLoop(i); else sw.slideTo(i);
    });
    sw.on('slideChange', function () { setActive(typeof sw.realIndex === 'number' ? sw.realIndex : sw.activeIndex); });
    setActive(sw.realIndex || 0);
    return true;
  }
  var tries = 0;
  (function init() {
    var scopes = [].slice.call(document.querySelectorAll('.productswiper-wrap .display-for-variant'));
    var pending = false;
    scopes.forEach(function (s) { if (!s.__cfThumbsWired) { if (wire(s)) s.__cfThumbsWired = true; else pending = true; } });
    if (pending && tries++ < 40) setTimeout(init, 300);
  })();
})();

/* ===== CreativeFold — Footer Klaviyo signup: set email placeholder (form renders async) ===== */
(function () {
  var TEXT = 'Enter your email address';
  function apply() {
    var form = document.querySelector('.klaviyo-form-V4Xt2f');
    if (!form) return false;
    var input = form.querySelector('input[type="email"], input[type="text"]:not([type="hidden"])');
    if (input && input.placeholder !== TEXT) input.setAttribute('placeholder', TEXT);
    return !!input;
  }
  if (apply()) return;
  var tries = 0;
  var iv = setInterval(function () { if (apply() || tries++ > 40) clearInterval(iv); }, 300);
  // Klaviyo can re-render on interaction — keep the placeholder set
  var host = document.querySelector('.klaviyo-form-V4Xt2f');
  if (host && window.MutationObserver) { new MutationObserver(apply).observe(host, { childList: true, subtree: true }); }
})();
/* Dynamic Finish the Look recommendations */
document.addEventListener('DOMContentLoaded', function () {
  var dataElement = document.querySelector('[data-finish-look-data]');
  var section = document.querySelector('[data-finish-look]');
  var productList = document.querySelector('[data-finish-look-products]');

  if (!dataElement || !section || !productList) return;

  var context;
  try {
    context = JSON.parse(dataElement.textContent);
  } catch (error) {
    return;
  }

  var storageKey = 'theendRecentlyViewed';
  var recentHandles = [];

  try {
    recentHandles = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (!Array.isArray(recentHandles)) recentHandles = [];
  } catch (error) {
    recentHandles = [];
  }

  recentHandles = recentHandles.filter(function (handle) {
    return handle && handle !== context.handle;
  }).slice(0, 11);

  try {
    localStorage.setItem(storageKey, JSON.stringify([context.handle].concat(recentHandles)));
  } catch (error) {}

  function tagsWithPrefix(tags, prefix) {
    return (tags || []).filter(function (tag) {
      return String(tag).toLowerCase().indexOf(prefix) === 0;
    }).map(function (tag) {
      return String(tag).toLowerCase();
    });
  }

  function inferProductTags(product) {
    var tags = (product.tags || []).slice();
    var searchable = [product.title, product.type, product.handle].filter(Boolean).join(' ').toLowerCase();

    function addTag(tag) {
      if (tags.map(function (item) { return String(item).toLowerCase(); }).indexOf(tag) === -1) {
        tags.push(tag);
      }
    }

    if (/mirror/.test(searchable)) {
      addTag('category:decor');
      addTag('subcategory:mirrors');
    }
    if (/dining[ -]?table/.test(searchable)) {
      addTag('category:tables');
      addTag('subcategory:dining-tables');
    } else if (/coffee[ -]?table/.test(searchable)) {
      addTag('category:tables');
      addTag('subcategory:coffee-tables');
    } else if (/side[ -]?table/.test(searchable)) {
      addTag('category:tables');
      addTag('subcategory:side-tables');
    } else if (/table/.test(searchable)) {
      addTag('category:tables');
    }
    if (/dining[ -]?chair/.test(searchable)) {
      addTag('category:seating');
      addTag('subcategory:dining-chairs');
    } else if (/chair|seat|bench/.test(searchable)) {
      addTag('category:seating');
    }
    if (/lamp|sconce|pendant|chandelier|light/.test(searchable)) {
      addTag('category:lighting');
    }
    if (/console|cabinet|sideboard|shelf|storage/.test(searchable)) {
      addTag('category:storage');
    }
    if (/sculpture|sculptural|statue|object/.test(searchable)) {
      addTag('category:decor');
      addTag('subcategory:sculpture');
    }

    var type = String(product.type || '').toLowerCase();
    if (type.indexOf('seating') !== -1) addTag('category:seating');
    if (type.indexOf('table') !== -1) addTag('category:tables');
    if (type.indexOf('light') !== -1) addTag('category:lighting');
    if (type.indexOf('storage') !== -1) addTag('category:storage');
    if (type.indexOf('decor') !== -1) addTag('category:decor');

    return tags;
  }

  context.tags = inferProductTags(context);

  function sharesTag(left, right, prefix) {
    var leftTags = tagsWithPrefix(left, prefix);
    var rightTags = tagsWithPrefix(right, prefix);
    return leftTags.some(function (tag) { return rightTags.indexOf(tag) !== -1; });
  }

  function relationshipScore(candidate, anchors) {
    var score = anchors.reduce(function (total, anchor) {
      if (sharesTag(candidate.tags, anchor.tags, 'finish:')) total += 10;
      if (sharesTag(candidate.tags, anchor.tags, 'material:')) total += 7;
      if (sharesTag(candidate.tags, anchor.tags, 'room:')) total += 3;
      if (sharesTag(candidate.tags, anchor.tags, 'category:')) total += 1;
      return total;
    }, 0);

    if (score > 0 && !sharesTag(candidate.tags, context.tags, 'category:')) score += 25;
    return score;
  }

  function complementaryPriority(product) {
    var currentIsDiningChair = tagsWithPrefix(context.tags, 'subcategory:').indexOf('subcategory:dining-chairs') !== -1;
    var currentCategories = tagsWithPrefix(context.tags, 'category:');

    if (currentIsDiningChair) {
      if (tagsWithPrefix(product.tags, 'subcategory:').indexOf('subcategory:dining-tables') !== -1) return 0;
      if (tagsWithPrefix(product.tags, 'subcategory:').indexOf('subcategory:mirrors') !== -1) return 1;
      if (tagsWithPrefix(product.tags, 'category:').indexOf('category:lighting') !== -1) return 2;
      if (tagsWithPrefix(product.tags, 'category:').indexOf('category:tables') !== -1) return 3;
      if (tagsWithPrefix(product.tags, 'category:').indexOf('category:storage') !== -1) return 4;
      if (tagsWithPrefix(product.tags, 'category:').indexOf('category:decor') !== -1) return 5;
      return 9;
    }

    var categoryOrder = currentCategories.indexOf('category:tables') !== -1
      ? ['category:seating', 'category:lighting', 'subcategory:mirrors', 'category:storage', 'category:decor']
      : currentCategories.indexOf('category:lighting') !== -1
        ? ['category:tables', 'category:seating', 'subcategory:mirrors', 'category:decor']
        : currentCategories.indexOf('category:decor') !== -1
          ? ['category:tables', 'category:seating', 'category:lighting', 'category:storage', 'category:decor']
          : ['category:tables', 'subcategory:mirrors', 'category:lighting', 'category:storage', 'category:decor'];

    for (var i = 0; i < categoryOrder.length; i += 1) {
      var prefix = categoryOrder[i].split(':')[0] + ':';
      if (tagsWithPrefix(product.tags, prefix).indexOf(categoryOrder[i]) !== -1) return i;
    }

    return 9;
  }

  function diversifyProducts(products) {
    var sorted = (products || []).map(function (product, index) {
      return {
        product: product,
        index: index,
        priority: complementaryPriority(product)
      };
    }).sort(function (left, right) {
      if (left.priority !== right.priority) return left.priority - right.priority;
      return left.index - right.index;
    }).map(function (entry) {
      return entry.product;
    });

    var usedGroups = {};
    var diverse = [];
    var repeats = [];

    sorted.forEach(function (product) {
      var subcategories = tagsWithPrefix(product.tags, 'subcategory:');
      var categories = tagsWithPrefix(product.tags, 'category:');
      var group = subcategories[0] || categories[0] || product.handle;

      if (usedGroups[group]) {
        repeats.push(product);
      } else {
        usedGroups[group] = true;
        diverse.push(product);
      }
    });

    return diverse.concat(repeats);
  }

  function productIsAvailable(product) {
    if (typeof product.available === 'boolean') return product.available;
    return (product.variants || []).some(function (variant) { return variant.available; });
  }

  function addUnique(target, seen, products) {
    (products || []).forEach(function (product) {
      if (target.length >= 4) return;
      if (!product || !product.handle || product.handle === context.handle) return;
      if (seen[product.handle] || !productIsAvailable(product)) return;
      seen[product.handle] = true;
      target.push(product);
    });
  }

  function recommendationGroup(product) {
    var subcategories = tagsWithPrefix(product.tags, 'subcategory:');
    var categories = tagsWithPrefix(product.tags, 'category:');

    if (subcategories.indexOf('subcategory:mirrors') !== -1) return 'mirrors';
    if (subcategories.indexOf('subcategory:sculpture') !== -1) return 'sculpture';
    if (categories.indexOf('category:tables') !== -1) return 'tables';
    if (categories.indexOf('category:seating') !== -1) return 'seating';
    if (categories.indexOf('category:lighting') !== -1) return 'lighting';
    if (categories.indexOf('category:storage') !== -1) return 'storage';
    if (categories.indexOf('category:decor') !== -1) return 'decor';
    return subcategories[0] || categories[0] || product.handle;
  }

  function addDiverse(target, seen, usedGroups, products, allowRepeatedGroups) {
    (products || []).forEach(function (product) {
      if (target.length >= 4) return;
      if (!product || !product.handle || product.handle === context.handle) return;
      if (seen[product.handle] || !productIsAvailable(product)) return;

      var group = recommendationGroup(product);
      if (!allowRepeatedGroups && usedGroups[group]) return;

      seen[product.handle] = true;
      usedGroups[group] = true;
      target.push(product);
    });
  }

  function imageUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function productPrice(product) {
    var price = product.price;
    if (!price) {
      var paidPrices = (product.variants || []).map(function (variant) {
        return variant.price;
      }).filter(function (variantPrice) { return variantPrice > 0; });
      if (paidPrices.length) price = Math.min.apply(Math, paidPrices);
    }

    var currency = window.Shopify && Shopify.currency && Shopify.currency.active
      ? Shopify.currency.active
      : 'AUD';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0
      }).format((price || 0) / 100);
    } catch (error) {
      return '$' + ((price || 0) / 100).toLocaleString();
    }
  }

  function escapeHtml(value) {
    var element = document.createElement('div');
    element.textContent = value || '';
    return element.innerHTML;
  }

  function renderProduct(product) {
    var featuredImage = product.featured_image || (product.images && product.images[0]) || '';
    return '<li>' +
      '<a class="product-card" href="/products/' + encodeURIComponent(product.handle) + '">' +
        '<div class="product-thumb">' +
          '<div class="image image-cover lazy-bg loaded" style="background-image:url(&quot;' +
            escapeHtml(imageUrl(featuredImage, 400)) + '&quot;)"></div>' +
        '</div>' +
        '<p><span>' + escapeHtml(product.title) + '</span>' +
        '<span class="price">' + escapeHtml(productPrice(product)) + '</span></p>' +
      '</a>' +
    '</li>';
  }

  Promise.all([
    fetch('/collections/all/products.json?limit=250&sort_by=best-selling').then(function (response) {
      return response.ok ? response.json() : { products: [] };
    }).catch(function () { return { products: [] }; }),
    fetch('/cart.js').then(function (response) {
      return response.ok ? response.json() : { items: [] };
    }).catch(function () { return { items: [] }; }),
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(context.productId) + '&limit=12&intent=related').then(function (response) {
      return response.ok ? response.json() : { products: [] };
    }).catch(function () { return { products: [] }; })
  ]).then(function (responses) {
    var catalogue = responses[0].products || [];
    var cart = responses[1];
    var automatic = responses[2].products || [];
    var byHandle = {};
    var byId = {};

    catalogue.forEach(function (product) {
      product.tags = inferProductTags(product);
      byHandle[product.handle] = product;
      byId[String(product.id)] = product;
    });

    automatic.forEach(function (product) {
      product.tags = inferProductTags(product);
    });

    var anchors = recentHandles.map(function (handle) {
      return byHandle[handle];
    }).filter(Boolean);

    (cart.items || []).forEach(function (item) {
      var cartProduct = byId[String(item.product_id)];
      if (cartProduct && !anchors.some(function (anchor) { return anchor.id === cartProduct.id; })) {
        anchors.push(cartProduct);
      }
    });

    var behavioural = catalogue.map(function (candidate) {
      return { product: candidate, score: relationshipScore(candidate, anchors) };
    }).filter(function (entry) {
      return entry.score > 0;
    }).sort(function (left, right) {
      return right.score - left.score;
    }).map(function (entry) { return entry.product; });

    var sameFinishDifferentCategory = catalogue.filter(function (candidate) {
      return sharesTag(candidate.tags, context.tags, 'finish:') &&
        !sharesTag(candidate.tags, context.tags, 'category:');
    });

    var manual = (context.manualHandles || []).map(function (handle) {
      return byHandle[handle] || { handle: handle, available: true };
    });

    var selected = [];
    var seen = {};
    var usedRecommendationGroups = {};
    var crossCategoryBehavioural = behavioural.filter(function (candidate) {
      return !sharesTag(candidate.tags, context.tags, 'category:');
    });
    var crossCategoryAutomatic = automatic.concat(catalogue).filter(function (candidate) {
      return !sharesTag(candidate.tags, context.tags, 'category:');
    });
    var sameCategoryFallback = behavioural.concat(automatic, catalogue).filter(function (candidate) {
      return sharesTag(candidate.tags, context.tags, 'category:');
    });

    addDiverse(selected, seen, usedRecommendationGroups, diversifyProducts(crossCategoryBehavioural), false);
    addDiverse(selected, seen, usedRecommendationGroups, diversifyProducts(sameFinishDifferentCategory), false);
    addDiverse(selected, seen, usedRecommendationGroups, manual, true);
    addDiverse(selected, seen, usedRecommendationGroups, diversifyProducts(crossCategoryAutomatic), false);
    addDiverse(selected, seen, usedRecommendationGroups, diversifyProducts(crossCategoryAutomatic), true);
    addDiverse(selected, seen, usedRecommendationGroups, diversifyProducts(sameCategoryFallback), false);
    addDiverse(selected, seen, usedRecommendationGroups, diversifyProducts(sameCategoryFallback), true);

    return Promise.all(selected.slice(0, 4).map(function (product) {
      return fetch('/products/' + encodeURIComponent(product.handle) + '.js').then(function (response) {
        return response.ok ? response.json() : product;
      }).catch(function () { return product; });
    }));
  }).then(function (products) {
    if (!products.length) return;
    productList.innerHTML = products.map(renderProduct).join('');
    section.hidden = false;
  });
});
